import { useMutation } from '@apollo/client';
import queries from '@nc-aftermarket/config/queryDefs';
import getAuthRedirectUrl from './getAuthRedirectUrl';
import isAuthError from './isAuthError';

export default function useWatchMutation() {
  const [watch, watchQuery] = useMutation(queries.Watch, {
    refetchQueries: ['UserContext'],
  });
  return [
    async ({ add = [], remove = [] }) => {
      try {
        await watch({
          variables: { watch: add, unwatch: remove },
        });
      } catch (error) {
        if (isAuthError(error)) {
          window.location = getAuthRedirectUrl(
            `${window.location.pathname}?watch=${add.join(',')}`,
          );
        } else {
          throw error;
        }
      }
    },
    watchQuery,
  ];
}
